import _ from 'lodash';
import { debugError } from '../logging/DebugLogger';
export function onUndefined(value, undefinedValue) {
    if (value === undefined) {
        return undefinedValue;
    }
    return value;
}
export function onUndefinedUseDefined(value, undefinedValue) {
    if (value === undefined) {
        return undefinedValue;
    }
    return value;
}
export function autoOnUndefined(value) {
    if (value === undefined) {
        return 'auto';
    }
    return value;
}
export function warnAndFallbackOnUndefined(value) {
    if (value !== undefined) {
        return value;
    }
    debugError('A value was undefined, using fallback which can breaks the component!');
    switch (typeof value) {
        case 'number':
            return 0;
        default:
            return 0;
    }
}
/**
 * Returns an object where all properties of the allProps object, which starts with the baseType, are included
 * Sample:
 * allProps = { border: 1, borderTop: 2, someOtherProp: 3 };
 * onlyPropsWhichStartsWith(allProps, 'border') => { border: 1, borderTop: 2 };
 * @param allProps
 * @param baseType
 */
export function onlyPropsWhichStartsWith(allProps, baseType) {
    var result = {};
    Object.keys(allProps)
        .filter(function (key) { return key.startsWith(baseType); })
        .forEach(function (baseTypeProp) { return (result[baseTypeProp] = allProps[baseTypeProp]); });
    return result;
}
// ToDo: Remove this, this is from an old animation concept!
export function animatedPropsStyle(props) {
    var animatedProps = onlyPropsWhichStartsWith(props, 'animated');
    var result = {};
    Object.keys(animatedProps).forEach(function (animatedPropKey) {
        if (props[animatedPropKey] === undefined) {
            return;
        }
        var propName = _.lowerFirst(animatedPropKey.split('animated')[1]);
        result[propName] = props[animatedPropKey];
        // console.error(propName, typeof props[animatedPropKey], animatedPropKey);
        // style[0][propName] = props[animatedPropKey];
        // style[0].right = 'bla';
        // console.error(propName, animatedPropKey, props[animatedPropKey], style[0][propName], style[0]);
    });
    return result;
}
//# sourceMappingURL=ValueHelper.js.map